import * as ActionTypes from '../actions/types';
import xs from 'xstream';
import {BASE_URL} from "../helpers/constants";
import * as actions from "../actions/index";
import sampleCombine from 'xstream/extra/sampleCombine';
import { push } from 'react-router-redux'
import {reset} from "redux-form/immutable";

export function resetCategoryFormAfterCreate(sources) {
  const action$ = sources.ACTION
    .filter(action => action.type === ActionTypes.CREATE_CATEGORY_SUCCESS)
    .map(action => reset('category'));

  return {
    ACTION: action$,
  }
}

export function redirectAfterCategoryDelete(sources) {
  const action$ = sources.ACTION
    .filter(action => action.type === ActionTypes.DELETE_CATEGORY_SUCCESS)
    .map(action => (push('/categories')));

  return {
    ACTION: action$
  }
}

export function requestDeleteCategory(sources) {

  const state$ = sources.STATE;
  const token$ = state$.map(state => state.loggedInPerson.get('token'));

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.DELETE_CATEGORY)
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + 'api/categories/' + action.payload.id,
      category: 'requestDeleteCategory',
      method: 'DELETE',
      send: action.payload.sendBody,
      headers: {Authorization: token},
    }));

  let httpResponse$ = sources.HTTP
    .select('requestDeleteCategory')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 204)
    .map(response => actions.deleteCategorySuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function requestDeleteCategoryFailed(sources) {
  let httpResponse$ = sources.HTTP
    .select('requestDeleteCategory')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status !== 204)
    .map(response => actions.deleteCategoryFailed(response));

  return {
    ACTION: httpResponse$
  }
}

export function redirectAfterUpdateCategorySuccess(sources) {
  const action$ = sources.ACTION
    .filter(action => action.type === ActionTypes.UPDATE_CATEGORY_SUCCESS)
    .map(action => push('/categories'));

  return {
    ACTION: action$,
  }
}

export function requestUpdateCategory(sources) {

  const state$ = sources.STATE;
  const token$ = state$.map(state => state.loggedInPerson.get('token'));

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.UPDATE_CATEGORY)
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + 'api/categories/' + action.payload.id,
      category: 'requestUpdateCategory',
      method: 'PATCH',
      send: action.payload.sendBody,
      headers: {Authorization: token},
    }));

  let httpResponse$ = sources.HTTP
    .select('requestUpdateCategory')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 200)
    .map(response => actions.updateCategorySuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function requestUpdateCategoryFailed(sources) {
  let httpResponse$ = sources.HTTP
    .select('requestUpdateCategory')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status !== 200)
    .map(response => actions.updateCategoryFailed(response));

  return {
    ACTION: httpResponse$
  }
}

export function requestCategoryById(sources) {

  const state$ = sources.STATE;
  const token$ = state$.map(state => state.loggedInPerson.get('token'));

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.GET_CATEGORY_BY_ID)
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + 'api/categories/' + action.payload.id,
      category: 'requestCategoryById',
      method: 'GET',
      headers: {Authorization: token},
    }));

  let httpResponse$ = sources.HTTP
    .select('requestCategoryById')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 200)
    .map(response => actions.getCategoryByIdSuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function requestCategoryByIdFailed(sources) {
  let httpResponse$ = sources.HTTP
    .select('requestCategoryById')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status !== 200)
    .map(response => actions.getCategoryByIdFailed(response));

  return {
    ACTION: httpResponse$
  }
}

export function requestCreateCategory(sources) {

  const state$ = sources.STATE;
  const token$ = state$.map(state => state.loggedInPerson.get('token'));

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.CREATE_CATEGORY)
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + 'api/categories',
      category: 'requestCreateCategory',
      method: 'POST',
      send: action.payload.sendBody,
      headers: {Authorization: token},
    }));

  let httpResponse$ = sources.HTTP
    .select('requestCreateCategory')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 200)
    .map(response => actions.createCategorySuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function requestCreateCategoryFail(sources) {
  let httpResponse$ = sources.HTTP
    .select('requestCreateCategory')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status !== 200)
    .map(response => actions.createCategoryFailed(response));

  return {
    ACTION: httpResponse$
  }
}



// WEBPACK FOOTER //
// ./src/cycles/category.js